/* THE FRAME'S ONE LINE. Above every page the Shell says, quietly, the one thing that limits what the reader can do: the
   server not answering, or a license not in force or in its grace. Nothing when all is well, and nothing about the
   licence on the License page, which says it in full. */
import { problemOf, type Refusal } from './state.ts'
import type { LicenceState } from './licence.ts'

export type Banner = { tone: 'fail' | 'review'; text: string; link: { to: string; label: string } | null; retry: boolean }

export function shellBanner(path: string, worldError: Refusal | null, licence: LicenceState | null): Banner | null {
  if (worldError) {
    const p = problemOf(worldError)
    return { tone: 'fail', text: `${p.title}: ${p.message} ${p.nextText}`, link: null, retry: p.next === 'retry' || p.next === 'wait' }
  }
  if (licence && (!licence.inForce || licence.status === 'grace') && !path.startsWith('/license')) return { tone: 'review', text: licence.sentence, link: { to: '/license', label: 'The license' }, retry: false }
  return null
}
